import { createFileRoute, redirect } from "@tanstack/react-router";

// Order export now lives under Reports at /export-orders. This legacy
// Operations path redirects so existing links/bookmarks keep working.
export const Route = createFileRoute("/_authenticated/orders-export")({
  beforeLoad: () => {
    throw redirect({ to: "/export-orders" });
  },
});
